import { createStore } from '../.'

import { TransactionKind } from '../../clients/LedgerScannerClient'
import type { StateStorage } from 'zustand/middleware'

interface ActivitySettingsStore {
  activityTypes: TransactionKind[]
  addActivityType: (type: TransactionKind) => void
  removeActivityType: (type: TransactionKind) => void
}

export const createActivitySettingsStore = (storage: StateStorage) =>
  createStore<ActivitySettingsStore>(
    storage,
    (set, get) => ({
      activityTypes: [
        TransactionKind.Transfer,
        TransactionKind.Burn,
        TransactionKind.Mint,
        TransactionKind.Approve,
      ],
      addActivityType: (type) => {
        const currentTypes = get().activityTypes
        if (currentTypes.includes(type)) return

        set({ activityTypes: [...currentTypes, type] })
      },
      removeActivityType: (type) => {
        set({ activityTypes: get().activityTypes.filter((t) => t !== type) })
      },
    }),
    {
      persist: {
        name: 'activitySettings',
      },
    }
  )
